import { useMemo } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { GetLicensedProductsQuery } from '../graphql/GetLicensedProductsQuery.graphql';
import type { GetLicensedProductsQuery as GetLicensedProductsQueryType } from '../graphql/__types__/GetLicensedProductsQuery';

export const useLicensedProducts = () => {
	// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
	const { data } = useQuery<GetLicensedProductsQueryType>(GetLicensedProductsQuery);

	return useMemo(() => {
		const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
		return licensedProducts.reduce(
			(acc, product) => {
				if (product.licenseStatus !== 'ACTIVE') {
					return acc;
				}

				switch (product.productKey) {
					case 'jira-software':
						acc.hasJira = true;
						break;
					case 'loom':
						acc.hasLoom = true;
						break;
					default:
						break;
				}
				return acc;
			},
			{ hasJira: false, hasLoom: false },
		);
	}, [data]);
};
